import Link from '@mui/material/Link';
import PropTypes from 'prop-types';
import React from 'react';
import Typography from '@mui/material/Typography';
import withStyles from '@mui/styles/withStyles';

const styles = (theme) => ({
  root: {
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignSelf: 'flex-end',
    width: '100%',
  },
  row: {
    display: 'flex',
    justifyContent: 'center',
    padding: '2px 12px',
    fontSize: 11,
  },
  link: {
    color: theme.palette.text.secondary,
  },
});

function Footer(props) {
  const { classes } = props;
  const year = new Date().getFullYear();
  return (
    <div className={classes.root}>
      <Typography className={classes.row} color="textSecondary">
        {`Copyright © 2005-${year} Call-Em-All, LLC. All Rights Reserved.`}
      </Typography>
      <Typography className={classes.row} color="textSecondary">
        <Link
          className={classes.link}
          href="https://www.call-em-all.com/legal/privacy-policy"
          target="_blank"
        >
          Privacy Policy
        </Link>
        &nbsp; | &nbsp;
        <Link
          className={classes.link}
          href="https://www.call-em-all.com/legal/terms-of-use"
          target="_blank"
        >
          Terms Of Use
        </Link>
        &nbsp; | &nbsp;
        <Link
          className={classes.link}
          href="https://www.call-em-all.com/legal/responsible-use"
          target="_blank"
        >
          Responsible Use Policy
        </Link>
      </Typography>
    </div>
  );
}

Footer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Footer);
